import React from "react";
import { Button, Icon } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
import { useInfo } from "context/InfoContext";

export default function PersonalIdentificationContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { filters, filterData } = useInfo();
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign ||
    userData?.user_sess?.isAdmin ||
    userData?.idu === filters?.idu
      ? false
      : true;
  const identifications = Array.isArray(filters?.identification)
    ? filters.identification
    : [];

  return (
    <div
      key={
        "personal-identification-content-" + boxName + "-" + filters.key_form
      }
    >
      <div
        className={boxName + " row"}
        style={{
          borderTop: "2px solid #dcdbdb",
          borderBottom: "2px solid #dcdbdb",
          padding: "25px 10px",
          marginTop: "10px",
        }}
      >
        <h3
          className="col s9"
          style={{ color: "#5a5a5a", marginBottom: "20px", paddingLeft: "0px" }}
        >
          Identification(s)
        </h3>
        {!isCannotEdit ? (
          <div
            key={"btn-add-identification"}
            className="col s3"
            style={{ paddingRight: "0px" }}
          >
            <Button
              className="light-blue accent-2"
              node="button"
              waves="light"
              small={true}
              style={{
                marginBottom: "20px",
                paddingLeft: "5px",
                paddingRight: "5px",
                float: "right",
              }}
              onClick={handleEvents.BtnAddIdentification.OnClick}
            >
              Identification
              <Icon left style={{ marginRight: "8px", fontSize: "1.3rem" }}>
                add
              </Icon>
            </Button>
          </div>
        ) : (
          ""
        )}
        {identifications.length === 0 ? (
          <div
            className="col s12"
            style={{
              border: "1px dashed #dcdbdb",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "20px",
              color: "#6c6c6c",
            }}
          >
            No identification records found.
          </div>
        ) : (
          identifications.map((item, index) => {
            const isTypeOT = item.type === "OT";
            const showExpirationDate = item.type === "PS" || item.type === "WP";
            const canEditIdentificationField =
              !isCannotEdit && item.type === "NR" ? true : isCannotEdit;
            return (
              <div
                key={"identification-" + index}
                className="col s12"
                style={{
                  border: "1px dashed #dcdbdb",
                  padding: "20px 20px 5px 20px",
                  borderRadius: "12px",
                  marginBottom: "20px",
                }}
              >
                <div
                  className={boxName + " row"}
                  style={{ marginBottom: "0px" }}
                >
                  <FormFunc.SingleSelect
                    data={{
                      id: "identification_type_" + index,
                      name: "identification_type",
                      label: "ID Type",
                      options: filterData.data.id_type,
                      addClass: "col s4",
                      optionName: "name",
                      optionValue: "xml_id",
                      optionTitle: "",
                      optionNull: true,
                      defaultValue: item.type ?? "",
                      disabled: isCannotEdit,
                    }}
                    filters={filters}
                    events={handleEvents}
                  />
                  {item.type === "OT" ? (
                    <FormFunc.InputText
                      data={{
                        id: "identification_name_" + index,
                        name: "identification_name",
                        label: "ID Name",
                        addClass: "col s4",
                        defaultValue: item?.name ?? "",
                        disabled: isCannotEdit,
                      }}
                      events={handleEvents}
                    />
                  ) : (
                    ""
                  )}
                  <FormFunc.InputText
                    data={{
                      id: "identification_number_" + index,
                      name: "identification_number",
                      label: "ID Number",
                      addClass:
                        "col " + (isTypeOT || showExpirationDate ? "s4" : "s8"),
                      defaultValue: item?.number,
                      disabled: canEditIdentificationField,
                    }}
                    events={handleEvents}
                  />
                  {showExpirationDate ? (
                    <FormFunc.InputDate
                      data={{
                        id: "identification_expiration_date_" + index,
                        name: "identification_expiration_date",
                        label:
                          item.type === "WP"
                            ? "Expiration Date*"
                            : "Expiration Date",
                        addClass: "col s4",
                        defaultValue: item?.expiration_date ?? "",
                        required: item.type === "WP",
                        disabled: canEditIdentificationField,
                      }}
                      events={handleEvents}
                    />
                  ) : (
                    ""
                  )}
                  <FormFunc.InputText
                    data={{
                      id: "identification_description_" + index,
                      name: "identification_description",
                      label: "Please add this smaller text for description",
                      addClass: "col s12",
                      defaultValue: item.description,
                      disabled: canEditIdentificationField,
                    }}
                    events={handleEvents}
                  />
                  <FormFunc.InputText
                    data={{
                      id: "identification_link_" + index,
                      name: "identification_link",
                      label: "Link to Document",
                      addClass: "col " + (!isCannotEdit ? "s11" : "s12"),
                      defaultValue: item.link,
                      disabled: canEditIdentificationField,
                    }}
                    events={handleEvents}
                  />
                  {!isCannotEdit ? (
                    <div className="col s1">
                      <Button
                        className="red accent-2"
                        floating
                        node="button"
                        waves="light"
                        icon={<Icon>delete</Icon>}
                        style={{ marginTop: "25px", float: "right" }}
                        index={index}
                        onClick={handleEvents.BtnDeleteIdentification.OnClick}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
      {!isCannotEdit ? (
        <div
          className={boxName + " row"}
          style={{ textAlign: "center", marginTop: "30px" }}
        >
          <Button
            className=""
            id="btn-save"
            node="button"
            waves="light"
            style={{ width: "150px" }}
            onClick={handleEvents.OnSave}
          >
            Save
          </Button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
